import * as React from 'react';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type SvgObjectivesStep3Props = React.SVGProps<SVGSVGElement>;

const SvgObjectivesStep3 = (props: SvgObjectivesStep3Props) => (
  <svg height={132} viewBox="0 0 313 132" width={313} role="presentation" {...props}>
    <title id="SvgObjectivesStep3-Title">{_t('Track your progress')}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h313v132H0z" fill="var(--cds-color-grey-25)" />
      <rect fill="var(--cds-color-grey-25)" height={9.074} rx={4.537} width={130} x={92} y={34.216} />
      <path d="M96.537 34.216h45.823v9.075H96.537a4.537 4.537 0 010-9.075z" fill="var(--cds-color-yellow-200)" />
      <path
        d="M149.303 29.493a3.295 3.295 0 00-3.469 0l-6.28 3.885a3.272 3.272 0 00-1.551 2.733V40.8a3.259 3.259 0 001.542 2.902l6.153 3.806a3.295 3.295 0 003.468 0l6.281-3.885a3.272 3.272 0 001.552-2.78v-4.683a3.26 3.26 0 00-1.543-2.86z"
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-yellow-200)"
        strokeWidth={4}
      />
      <path
        d="M184.359 31.867l-3.095 1.943a1.24 1.24 0 01-1.318 0l-3.036-1.905a1 1 0 01.526-1.847l6.385-.038a1 1 0 01.538 1.847z"
        fill="var(--cds-color-grey-800)"
      />
      <g transform="translate(92 84.683)">
        <rect fill="var(--cds-color-grey-25)" height={9.074} rx={4.537} width={130} y={5} />
        <path
          d="M62.359 2.184l-3.095 1.943a1.24 1.24 0 01-1.318 0L54.91 2.222a1 1 0 01.526-1.847L61.82.337a1 1 0 01.538 1.847z"
          fill="var(--cds-color-grey-800)"
        />
      </g>
      <path
        d="M115.64 85.226a3.295 3.295 0 00-3.468 0l-6.28 3.885a3.272 3.272 0 00-1.551 2.734v4.687a3.259 3.259 0 001.541 2.903l6.154 3.806a3.295 3.295 0 003.468 0l6.281-3.885a3.272 3.272 0 001.552-2.781v-4.683a3.26 3.26 0 00-1.543-2.86z"
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-yellow-200)"
        strokeWidth={4}
      />
      <path d="M96.537 89.683h7.804v9.074h-7.804a4.537 4.537 0 010-9.074z" fill="var(--cds-color-yellow-200)" />
      <rect fill="var(--cds-color-grey-25)" height={9.074} rx={4.537} width={130} x={92} y={61.95} />
      <path d="M96.537 61.95H185v9.074H96.537a4.537 4.537 0 110-9.074z" fill="var(--cds-color-yellow-200)" />
      <path
        d="M114.359 59.867l-3.095 1.943a1.24 1.24 0 01-1.318 0l-3.036-1.905a1 1 0 01.526-1.847l6.385-.038a1 1 0 01.538 1.847z"
        fill="var(--cds-color-grey-800)"
      />
      <path
        d="M195.303 57.226a3.295 3.295 0 00-3.469 0l-6.28 3.885a3.272 3.272 0 00-1.551 2.734v4.687a3.259 3.259 0 001.542 2.903l6.153 3.806a3.295 3.295 0 003.468 0l6.281-3.885A3.272 3.272 0 00203 68.575v-4.683a3.26 3.26 0 00-1.543-2.86z"
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-yellow-200)"
        strokeWidth={4}
      />
    </g>
  </svg>
);

export default SvgObjectivesStep3;
